/* eslint-disable new-cap */
import { LiveStatus } from 'src/pages/CommunityDetails/Posts/live'

import apiSparkle from '../apiSparkle'
import { LiveEndpoints, WEBINAR_PAGE_SIZE } from './constants'
import { GetWebinarsParams, LiveResponse, LiveSortParams } from './types'

class LiveService {
  static async getCommunityWebinars(
    communityId: number,
    filters?: GetWebinarsParams,
    signal?: AbortSignal
  ) {
    const params = new URLSearchParams({
      locale:
        filters?.locale ??
        Intl.DateTimeFormat?.()?.resolvedOptions?.()?.timeZone ??
        'America/Sao_Paulo',
      sort: filters?.sort ?? LiveSortParams.LIVE_START_AT_DESCENDING,
      status: filters?.status ?? LiveStatus.STARTED,
      rows: `${filters?.rows ?? WEBINAR_PAGE_SIZE}`,
      page: `${filters?.page ?? 0}`
    })

    const { data } = await apiSparkle.get<LiveResponse>(LiveEndpoints.getWebinars(communityId), {
      signal,
      params
    })

    return data
  }
}

export default LiveService
